/**
 * Аппын шинэчлэл — сервер, утас, вэб гурвын хуваалцах дүрэм
 * (docs/ANDROID.md §7.3–7.4).
 *
 * Нийтэлсэн APK нь `tsaatan-media` bucket-ийн `releases/` угтвар дор:
 *
 *   releases/latest.json          ← сүүлийн хувилбарын заагч
 *   releases/<versionCode>/tsaatan.apk
 *
 * ⚠️ `versionName` нь build бүрд '0.1.0' хэвээр — хоёр APK-г ЗӨВХӨН
 *    `versionCode` (commit-ийн тоо, `app.config.ts`) ялгана.
 */
export const RELEASE_LATEST_KEY = 'releases/latest.json';
/** Нэг хувилбарын APK — versionCode тутамд тусдаа түлхүүр, дарж бичихгүй. */
export function releaseApkKey(versionCode) {
    if (!Number.isInteger(versionCode) || versionCode < 1) {
        throw new Error(`releaseApkKey: versionCode эерэг бүхэл тоо байх ёстой, ирсэн: ${versionCode}`);
    }
    return `releases/${versionCode}/tsaatan.apk`;
}
/**
 * Апп серверт илгээх хувилбарын шошго (`devices.app_version`): `0.1.0 (320)`.
 * Build дугааргүй бол вэбийн Төхөөрөмж хуудас хуучирсан аппыг ялгаж чадахгүй.
 */
export function appVersionLabel(versionName, versionCode) {
    return `${versionName} (${versionCode})`;
}
/** Шошгоос build дугаар. Build дугаар илгээдэггүй хуучин апп (`0.1.0`) → null. */
export function buildFromAppVersion(label) {
    const m = label ? /\((\d+)\)\s*$/.exec(label) : null;
    return m ? Number(m[1]) : null;
}
/**
 * Төхөөрөмжийн апп сүүлийн хувилбараас хоцорсон эсэх.
 * Build дугааргүй шошго = 288-аас өмнөх апп тул хоцорсон гэж үзнэ.
 */
export function isAppOutdated(label, latestVersionCode) {
    if (!label)
        return false; // хэзээ ч нэвтрээгүй төхөөрөмж — хувилбар мэдэгдэхгүй
    const build = buildFromAppVersion(label);
    return build === null || build < latestVersionCode;
}
//# sourceMappingURL=mobile-release.js.map